{
  "PROFILE_SETTINGS": {
    "LINK": "Profila Iestatījumi",
    "TITLE": "Profila Iestatījumi",
    "BTN_TEXT": "Atjaunināt Profilu",
    "DELETE_AVATAR": "Dzēst Avatāru",
    "AVATAR_DELETE_SUCCESS": "Avatārs ir veiksmīgi izdzēsts",
    "AVATAR_DELETE_FAILED": "Avatāra dzēšanas laikā radās kļūda. Lūdzu, mēģiniet vēlreiz",
    "UPDATE_SUCCESS": "Jūsu profils ir veiksmīgi atjaunināts",
    "PASSWORD_UPDATE_SUCCESS": "Jūsu parole ir veiksmīgi nomainīta",
    "AFTER_EMAIL_CHANGED": "Jūsu profils ir veiksmīgi atjaunināts. Lūdzu, atkārtoti pierakstieties, jo Jūsu akreditācijas dati ir mainīti",
    "FORM": {
      "PICTURE": "Profila Attēls",
      "AVATAR": "Profila Attēls",
      "ERROR": "Lūdzu, izlabojiet veidlapas kļūdas",
      "REMOVE_IMAGE": "Noņemt",
      "UPLOAD_IMAGE": "Augšupielādēt attēlu",
      "UPDATE_IMAGE": "Atjaunināt attēlu",
      "PROFILE_SECTION": {
        "TITLE": "Profils",
        "NOTE": "Jūsu e -pasta adrese ir jūsu identitāte, un to izmanto lai pierakstītos."
      },
      "SEND_MESSAGE": {
        "TITLE": "Karstais taustiņš ziņojumu sūtīšanai",
        "NOTE": "Jūs varat izvēlēties karsto taustiņu (vai nu Enter, vai Cmd/Ctrl+Enter), pamatojoties uz Jūsu rakstības ieradumiem.",
        "UPDATE_SUCCESS": "Jūsu iestatījumi ir veiksmīgi atjaunināti",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Enter (↵)",
            "CONTENT": "Sūtīt ziņojumus, nospiežot taustiņu Enter, nevis noklikšķinot uz pogas Sūtīt."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (⌘ + ↵)",
            "CONTENT": "Sūtīt ziņojumus, nospiežot taustiņu Cmd/Ctrl + Enter, nevis noklikšķinot uz pogas Sūtīt."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Interfeiss",
        "NOTE": "Pielāgot sava Chatwoot informācijas paneļa izskatu un darbību.",
        "FONT_SIZE": {
          "TITLE": "Fonta lielums",
          "NOTE": "Pielāgot teksta lielumu informācijas panelī, atbilstoši savām vēlmēm.",
          "UPDATE_SUCCESS": "Fonta iestatījumi ir veiksmīgi atjaunināti",
          "UPDATE_ERROR": "Atjauninot fonta iestatījumus radās kļūda. Lūdzu, mēģiniet vēlreiz",
          "OPTIONS": {
            "SMALLER": "Mazāks",
            "SMALL": "Mazs",
            "DEFAULT": "Noklusējums",
            "LARGE": "Liels",
            "LARGER": "Lielāks",
            "EXTRA_LARGE": "Īpaši Liels"
          }
        },
        "LANGUAGE": {
          "TITLE": "Preferred Language",
          "NOTE": "Choose the language you want to use.",
          "UPDATE_SUCCESS": "Your Language settings have been updated successfully",
          "UPDATE_ERROR": "There is an error while updating the language settings, please try again",
          "USE_ACCOUNT_DEFAULT": "Use account default"
        }
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "Personīgais ziņojuma paraksts",
        "NOTE": "Izveidot unikālu ziņojuma parakstu, kas parādās katra ziņojuma beigās, kuru sūtāt no jebkuras iesūtnes. Varat arī iekļaut attēlu, kas tiek atbalstīts tiešraidē, e-pastā un API iesūtnēs.",
        "BTN_TEXT": "Saglabāt ziņojuma parakstu",
        "API_ERROR": "Nevarēja saglabāt parakstu! Lūdzu, mēģiniet vēlreiz",
        "API_SUCCESS": "Paraksts ir veiksmīgi saglabāts",
        "IMAGE_UPLOAD_ERROR": "Nevarēja augšupielādēt attēlu! Lūdzu, mēģiniet vēlreiz",
        "IMAGE_UPLOAD_SUCCESS": "Attēls ir veiksmīgi pievienots. Lūdzu, noklikšķiniet uz saglabāt, lai saglabātu parakstu",
        "IMAGE_UPLOAD_SIZE_ERROR": "Attēla izmēram ir jābūt mazākam par {size}MB",
        "INLINE_IMAGE_WARNING": "Pasted inline images were removed. Please use the image upload button to add images to your signature."
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "Ziņojuma Paraksts",
        "ERROR": "Ziņojuma Paraksts nevar būt tukšs",
        "PLACEHOLDER": "Ievietojiet savu personīgo ziņojumu parakstu šeit."
      },
      "PASSWORD_SECTION": {
        "TITLE": "Parole",
        "NOTE": "Paroles atjaunināšana varētu atiestatīt jūsu pierakstīšanos vairākās ierīcēs.",
        "BTN_TEXT": "Mainīt paroli"
      },
      "SECURITY_SECTION": {
        "TITLE": "Security",
        "NOTE": "Manage additional security features for your account.",
        "MFA_BUTTON": "Manage Two-Factor Authentication"
      },
      "SESSIONS_SECTION": {
        "TITLE": "Active Sessions",
        "NOTE": "These are the devices currently logged in to your account.",
        "CURRENT": "Current session",
        "REVOKE": "Revoke",
        "REVOKE_SUCCESS": "Session revoked successfully",
        "REVOKE_ERROR": "Unable to revoke session. Please try again.",
        "FETCH_ERROR": "Unable to fetch sessions. Please try again.",
        "LAST_ACTIVE": "Last active",
        "UNKNOWN_DEVICE": "Unknown device"
      },
      "ACCESS_TOKEN": {
        "TITLE": "Piekļuves Token",
        "NOTE": "Šo token var izmantot, ja veidojat uz API balstītu integrāciju",
        "PAID_PLAN_NOTE": "API access tokens are available on paid plans.",
        "COPY": "Kopēt",
        "RESET": "Atiestatīt",
        "CONFIRM_RESET": "Are you sure?",
        "CONFIRM_HINT": "Click again to confirm",
        "RESET_SUCCESS": "Access token regenerated successfully",
        "RESET_ERROR": "Unable to regenerate access token. Please try again"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Audio Brīdinājumi",
        "NOTE": "Ieslēgt audio brīdinājumus informācijas panelī, priekš jauniem ziņojumiem un sarunām.",
        "PLAY": "Atskaņot skaņu",
        "ALERT_TYPES": {
          "NONE": "Nav",
          "MINE": "Piešķirts",
          "ALL": "Visi",
          "ASSIGNED": "Man piešķirtās sarunas",
          "UNASSIGNED": "Nepiešķirtās sarunas",
          "NOTME": "Atvērt citiem piešķirtās sarunas"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "Jūs neesat izvēlējies nevienu opciju, jūs nesaņemsiet audio brīdinājumus.",
          "ASSIGNED": "Jūs saņemsiet brīdinājumus par jums piešķirtajām sarunām.",
          "UNASSIGNED": "Jūs saņemsiet brīdinājumus par nepiešķirtām sarunām.",
          "NOTME": "Jūs saņemsiet brīdinājumus par sarunām, kas piešķirtas citiem.",
          "ASSIGNED+UNASSIGNED": "Jūs saņemsiet brīdinājumus par piešķirtajām sarunām un visām bez uzraudzības atstātām sarunām.",
          "ASSIGNED+NOTME": "Jūs saņemsiet brīdinājumus par sarunām, kas piešķirtas jums un citiem, bet ne par sarunām, kas nav piešķirtas.",
          "NOTME+UNASSIGNED": "Jūs saņemsiet brīdinājumus par sarunām, kas ir bez uzraudzības, kā arī par sarunām, kas piešķirtas citiem.",
          "ASSIGNED+NOTME+UNASSIGNED": "Jūs saņemsiet brīdinājumus par visām sarunām."
        },
        "ALERT_TYPE": {
          "TITLE": "Brīdinājuma notikumi sarunām",
          "NONE": "Nav",
          "ASSIGNED": "Piešķirtās Sarunas",
          "ALL_CONVERSATIONS": "Visas Sarunas"
        },
        "DEFAULT_TONE": {
          "TITLE": "Brīdinājumu signāls:"
        },
        "CONDITIONS": {
          "TITLE": "Brīdinājumu nosacījumi:",
          "CONDITION_ONE": "Sūtīt audio brīdinājumus tikai tad, ja pārlūkprogrammas logs nav aktīvs",
          "CONDITION_TWO": "Sūtīt brīdinājumus ik pēc 30 sekundēm, līdz visas piešķirtās sarunas ir izlasītas"
        },
        "SOUND_PERMISSION_ERROR": "Automātiskā atskaņošana jūsu pārlūkprogrammā ir atspējota. Lai automātiski dzirdētu brīdinājumus, pārlūkprogrammas iestatījumos iespējojiet skaņas atļauju vai mijiedarbojieties ar lapu.",
        "READ_MORE": "Lasīt vairāk"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "E-pasta Ziņojumi",
        "NOTE": "Atjauniniet savas e -pasta paziņojumu preferences šeit",
        "CONVERSATION_ASSIGNMENT": "Nosūtīt e -pasta paziņojumus, kad man tiek piešķirta saruna",
        "CONVERSATION_CREATION": "Nosūtīt e -pasta paziņojumus, kad tiek izveidota jauna saruna",
        "CONVERSATION_MENTION": "Nosūtīt e -pasta paziņojumus, kad tiekat pieminēts sarunā",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Nosūtīt e -pasta paziņojumus, kad piešķirtā sarunā tiek izveidots jauns ziņojums",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Sūtīt e-pasta paziņojumus, kad sarunā tiek izveidots jauns ziņojums",
        "SLA_MISSED_FIRST_RESPONSE": "Nosūtīt e-pasta paziņojumus, ja sarunā tiek nokavēts pirmās atbildes SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Nosūtīt e-pasta paziņojumus, ja sarunā tiek nokavēts nākamās atbildes SLA",
        "SLA_MISSED_RESOLUTION": "Nosūtīt e-pasta paziņojumus, ja sarunā tiek nokavēts atrisināšanas SLA"
      },
      "NOTIFICATIONS": {
        "TITLE": "Paziņojumu preferences",
        "TYPE_TITLE": "Paziņojuma veids",
        "EMAIL": "E-pasts",
        "PUSH": "Push paziņojums",
        "TYPES": {
          "CONVERSATION_CREATED": "Tiek izveidota jauna saruna",
          "CONVERSATION_ASSIGNED": "Jums ir piešķirta saruna",
          "CONVERSATION_MENTION": "Jūs esat pieminēts sarunā",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Piešķirtajā sarunā ir izveidots jauns ziņojums",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Dalības sarunā ir izveidots jauns ziņojums",
          "SLA_MISSED_FIRST_RESPONSE": "Sarunā ir nokavēts pirmās atbildes SLA",
          "SLA_MISSED_NEXT_RESPONSE": "Sarunā ir nokavēts nākamās atbildes SLA",
          "SLA_MISSED_RESOLUTION": "Sarunā ir nokavēts atrisināšanas SLA"
        },
        "BROWSER_PERMISSION": "Iespējojiet push paziņojumus savā pārlūkprogrammā, lai varētu tos saņemt"
      },
      "API": {
        "UPDATE_SUCCESS": "Jūsu paziņojumu preferences ir veiksmīgi atjauninātas",
        "UPDATE_ERROR": "Preferenču atjaunināšanas laikā radās kļūda. Lūdzu, mēģiniet vēlreiz"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "Push Paziņojumi",
        "NOTE": "Atjauniniet savas Push paziņojumu preferences šeit",
        "CONVERSATION_ASSIGNMENT": "Nosūtīt push paziņojumus, kad man tiek piešķirta saruna",
        "CONVERSATION_CREATION": "Nosūtīt push paziņojumus, kad tiek izveidota jauna saruna",
        "CONVERSATION_MENTION": "Nosūtīt push paziņojumus, kad tiekat pieminēts sarunā",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Nosūtīt push paziņojumus, kad piešķirtā sarunā tiek izveidots jauns ziņojums",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Sūtīt push paziņojumus, kad sarunā tiek izveidots jauns ziņojums",
        "HAS_ENABLED_PUSH": "Jūs esat iespējojis push šajā pārlūkprogrammā.",
        "REQUEST_PUSH": "Iespējot push paziņojumus",
        "SLA_MISSED_FIRST_RESPONSE": "Nosūtīt push paziņojumus, ja sarunā tiek nokavēts pirmās atbildes SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Nosūtīt push paziņojumus, ja sarunā tiek nokavēts nākamās atbildes SLA",
        "SLA_MISSED_RESOLUTION": "Nosūtīt push paziņojumus, ja sarunā tiek nokavēts atrisināšanas SLA"
      },
      "PROFILE_IMAGE": {
        "LABEL": "Profila Attēls"
      },
      "NAME": {
        "LABEL": "Jūsu pilnais vārds",
        "ERROR": "Lūdzu, ievadiet derīgu pilnu vārdu",
        "PLACEHOLDER": "Lūdzu, ievadiet savu pilno vārdu"
      },
      "DISPLAY_NAME": {
        "LABEL": "Parādāmais vārds",
        "ERROR": "Lūdzu, ievadiet derīgu parādāmo vārdu",
        "PLACEHOLDER": "Lūdzu, ievadiet parādāmo vārdu, tas tiks parādīts sarunās"
      },
      "AVAILABILITY": {
        "LABEL": "Pieejamība",
        "STATUS": {
          "ONLINE": "Tiešsaistē",
          "BUSY": "Aizņemts",
          "OFFLINE": "Bezsaistē"
        },
        "SET_AVAILABILITY_SUCCESS": "Pieejamība ir veiksmīgi iestatīta",
        "SET_AVAILABILITY_ERROR": "Nevarēja iestatīt pieejamību. Lūdzu, mēģiniet vēlreiz",
        "IMPERSONATING_ERROR": "Cannot change availability while impersonating a user"
      },
      "EMAIL": {
        "LABEL": "Jūsu e-pasta adrese",
        "ERROR": "Lūdzu, ievadiet derīgu e-pasta adresi",
        "PLACEHOLDER": "Lūdzu, ievadiet savu e-pasta adresi, tā tiks parādīta sarunās"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "Pašreizējā parole",
        "ERROR": "Lūdzu, ievadiet pašreizējo paroli",
        "PLACEHOLDER": "Lūdzu, ievadiet pašreizējo paroli"
      },
      "PASSWORD": {
        "LABEL": "Jauna parole",
        "ERROR": "Lūdzu, ievadiet paroli, kuras garums ir 6 vai vairāk simboli",
        "PLACEHOLDER": "Lūdzu, ievadiet jauno paroli"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "Apstipriniet jauno paroli",
        "ERROR": "Apstiprinājuma parolei ir jāsakrīt ar paroli",
        "PLACEHOLDER": "Lūdzu, vēlreiz ievadiet savu jauno paroli"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "Mainīt",
    "CHANGE_ACCOUNTS": "Pārslēgt kontu",
    "SWITCH_ACCOUNT": "Pārslēgt kontu",
    "CONTACT_SUPPORT": "Sazināties ar atbalstu",
    "SELECTOR_SUBTITLE": "Izvēlieties kontu no šī saraksta",
    "PROFILE_SETTINGS": "Profila iestatījumi",
    "YEAR_IN_REVIEW": "Year in Review",
    "KEYBOARD_SHORTCUTS": "Tastatūras īsinājumtaustiņi",
    "APPEARANCE": "Mainīt izskatu",
    "SUPER_ADMIN_CONSOLE": "SuperAdmin konsole",
    "DOCS": "Lasīt dokumentāciju",
    "CHANGELOG": "Changelog",
    "LOGOUT": "Izrakstīties"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "izmēģinājuma dienas atlikušas.",
    "TRAIL_BUTTON": "Pirkt Tagad",
    "DELETED_USER": "Dzēsts Lietotājs",
    "EMAIL_VERIFICATION_PENDING": "Izskatās, ka Jūs vēl neesat verificējis savu e-pasta adresi. Lūdzu, izlasiet savā iesūtnē verifikācijas e-pasta ziņojumu.",
    "RESEND_VERIFICATION_MAIL": "Sūtīt verifikācijas e-pastu atkārtoti",
    "EMAIL_VERIFICATION_SENT": "Verifikācijas e-pasts ir nosūtīts. Lūdzu, pārbaudiet savu iesūtni.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "Konts Iesaldēts",
      "MESSAGE": "Jūsu konts ir iesaldēts. Lai iegūtu papildu informāciju, lūdzu, sazinieties ar atbalsta komandu."
    },
    "NO_ACCOUNTS": {
      "TITLE": "No account found",
      "MESSAGE_CLOUD": "You are not part of any accounts right now. If you think this is a mistake, please reach out to our support team.",
      "MESSAGE_SELF_HOSTED": "You are not part of any accounts right now. Please reach out to your administrator.",
      "LOGOUT": "Izrakstīties"
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "Kopēt",
      "CODEPEN": "Atvērt programmā CodePen",
      "COPY_SUCCESSFUL": "Kopēts starpliktuvē"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "Parādīt Vairāk",
      "SHOW_LESS": "Parādīt Mazāk"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "Lejupielādēt",
      "UPLOADING": "Notiek augšupielāde...",
      "INSTAGRAM_STORY_UNAVAILABLE": "Šis stāsts vairs nav pieejams.",
      "INSTAGRAM_STORY_REPLY": "Atbildēja uz Jūsu stāstu:"
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "Skatīt kartē"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Iesniegt"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "Šis attēls vairs nav pieejams.",
      "LOADING_FAILED": "Ielāde neizdevās"
    }
  },
  "CONFIRM_EMAIL": "Notiek pārbaude...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "Pievienot Iesūtni"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "Nav vienumu",
    "CURRENTLY_VIEWING_ACCOUNT": "Pašlaik skatās:",
    "SWITCH": "Pārslēgt",
    "INBOX_VIEW": "Iesūtnes Skats",
    "CONVERSATIONS": "Sarunas",
    "INBOX": "Mana Iesūtne",
    "ALL_CONVERSATIONS": "Visas Sarunas",
    "MENTIONED_CONVERSATIONS": "Pieminēšanas",
    "PARTICIPATING_CONVERSATIONS": "Piedalās",
    "UNATTENDED_CONVERSATIONS": "Bez uzraudzības",
    "REPORTS": "Pārskati",
    "SETTINGS": "Iestatījumi",
    "CONTACTS": "Kontaktpersonas",
    "ACTIVE": "Aktīvs",
    "COMPANIES": "Companies",
    "ALL_COMPANIES": "All Companies",
    "CAPTAIN": "Captain",
    "CAPTAIN_ASSISTANTS": "Asistenti",
    "CAPTAIN_OVERVIEW": "Pārskats",
    "CAPTAIN_DOCUMENTS": "Dokumenti",
    "CAPTAIN_RESPONSES": "Bieži uzdotie jautājumi",
    "CAPTAIN_TOOLS": "Tools",
    "CAPTAIN_SCENARIOS": "Scenarios",
    "CAPTAIN_PLAYGROUND": "Playground",
    "CAPTAIN_INBOXES": "Iesūtnes",
    "CAPTAIN_SETTINGS": "Iestatījumi",
    "HOME": "Sākums",
    "AGENTS": "Aģenti",
    "AGENT_BOTS": "Bots",
    "AUDIT_LOGS": "Audita Žurnāli",
    "INBOXES": "Iesūtnes",
    "NOTIFICATIONS": "Paziņojumi",
    "CANNED_RESPONSES": "Sagatavotās Atbildes",
    "INTEGRATIONS": "Integrācijas",
    "DATA": "Data",
    "PROFILE_SETTINGS": "Profila Iestatījumi",
    "ACCOUNT_SETTINGS": "Konta Iestatījumi",
    "APPLICATIONS": "Lietojumprogrammas",
    "LABELS": "Etiķetes",
    "CUSTOM_ATTRIBUTES": "Pielāgotas Īpašības",
    "AUTOMATION": "Automatizācija",
    "MACROS": "Macros",
    "TEAMS": "Komandas",
    "BILLING": "Norēķini",
    "CUSTOM_VIEWS_FOLDER": "Mapes",
    "CUSTOM_VIEWS_SEGMENTS": "Segmenti",
    "ALL_CONTACTS": "Visi Kontakti",
    "TAGGED_WITH": "Marķēts ar",
    "NEW_LABEL": "Jauna etiķete",
    "NEW_TEAM": "Jauna komanda",
    "NEW_INBOX": "Jauna iesūtne",
    "REPORTS_CONVERSATION": "Sarunas",
    "CSAT": "CSAT",
    "LIVE_CHAT": "Tiešraides tērzēšana",
    "SMS": "SMS",
    "WHATSAPP": "WhatsApp",
    "CAMPAIGNS": "Kampaņas",
    "ONGOING": "Notiekošs",
    "ONE_OFF": "Vienreizējs",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "Bot",
    "REPORTS_AGENT": "Aģenti",
    "REPORTS_LABEL": "Etiķetes",
    "REPORTS_INBOX": "Iesūtne",
    "REPORTS_TEAM": "Komanda",
    "AGENT_ASSIGNMENT": "Agent Assignment",
    "SET_AVAILABILITY_TITLE": "Iestatīt sevi kā",
    "SET_YOUR_AVAILABILITY": "Iestatīt savu pieejamību",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Pielāgotas lomas",
    "BETA": "Beta",
    "REPORTS_OVERVIEW": "Pārskats",
    "REAUTHORIZE": "Jūsu iesūtnes savienojuma termiņš ir beidzies. Lūdzu, pievienojiet vēlreiz\n lai turpinātu saņemt un sūtīt ziņas",
    "HELP_CENTER": {
      "TITLE": "Palīdzības centrs",
      "ARTICLES": "Raksti",
      "CATEGORIES": "Kategorijas",
      "LOCALES": "Lokalizācijas",
      "SETTINGS": "Iestatījumi"
    },
    "CHANNELS": "Kanāli",
    "SET_AUTO_OFFLINE": {
      "TEXT": "Automātiski atzīmēt bezsaistē",
      "INFO_TEXT": "Ļaut sistēmai, kad neizmantojat lietotni vai informācijas paneli, automātiski atzīmēt Jūs bezsaistē.",
      "INFO_SHORT": "Automātiski atzīmēt bezsaistē, kad neizmantojat lietotni."
    },
    "SORT_TOOLTIP": "Šķirot",
    "SORT_BY": "Kārtot pēc",
    "SORT_GROUPS": {
      "CREATED": "Sort by date of creation",
      "ALPHABETICAL": "Sort in alphabetical order",
      "UNREAD_COUNT": "Sort by unread count"
    },
    "SORT_OPTIONS": {
      "CREATED_DESC": "Newest first",
      "CREATED_ASC": "Oldest first",
      "ALPHABETICAL_ASC": "Ascending (A - Z)",
      "ALPHABETICAL_DESC": "Descending (Z - A)",
      "UNREAD_COUNT_DESC": "Highest first",
      "UNREAD_COUNT_ASC": "Lowest first"
    },
    "DOCS": "Lasīt dokumentus",
    "SECURITY": "Security",
    "CAPTAIN_AI": "Captain",
    "CONVERSATION_WORKFLOW": "Conversation Workflow"
  },
  "DATA_IMPORTS": {
    "HEADER": "Data",
    "DESCRIPTION": "Bring your existing contacts and past conversations into this account from another support tool. Each import runs in the background, so you can keep working while it finishes, track its progress, and review anything that was skipped along the way.",
    "LOADING": "Fetching imports",
    "DEFAULT_IMPORT_NAME": "Intercom import",
    "TABS": {
      "IMPORT": "Importēt",
      "EXPORT": "Eksportēt"
    },
    "TYPES": {
      "CONTACTS": "Kontaktpersonas",
      "CONVERSATIONS": "Sarunas",
      "MESSAGES": "Ziņojumi"
    },
    "DRAWER": {
      "TITLE": "New import",
      "SOURCE": "Source",
      "NAME": "Import name",
      "NAME_PLACEHOLDER": "July Intercom migration",
      "ACCESS_KEY": "Intercom access key",
      "ACCESS_KEY_PLACEHOLDER": "Paste your Intercom access key",
      "DATA_TYPES": "Data to import",
      "VALIDATING": "Validating access key...",
      "VALID_KEY": "Access key validated.",
      "INVALID_KEY": "Could not validate this access key.",
      "ACTIVE_IMPORT": "Wait for the active import to finish before starting another one.",
      "CANCEL": "Atcelt",
      "IMPORT": "Importēt"
    },
    "EXPORT": {
      "TITLE": "Exports are on the way",
      "DESCRIPTION": "Export your contacts and conversations out of this account. This workflow is coming soon.",
      "COMING_SOON": "Coming soon"
    },
    "TABLE": {
      "TITLE": "Recent imports",
      "EMPTY": "No imports yet",
      "EMPTY_DESCRIPTION": "Start an import to bring your existing customer history into this account.",
      "NEW_IMPORT": "Importēt",
      "COUNT": "{count} imports",
      "UNNAMED": "Untitled import",
      "IMPORTED_COUNT": "{count} imported",
      "VIEW": "View import",
      "NAME": "Nosaukums",
      "TYPE": "Tips",
      "STATUS": "Statuss",
      "IMPORTED": "Imported",
      "CREATED": "Izveidots",
      "ABANDON": "Abandon"
    },
    "DETAIL": {
      "BACK": "Back to imports",
      "ERRORS": "Errors",
      "SKIP_LOGS": "Skip logs",
      "SOURCE": "Source",
      "IMPORT_TYPES": "Import types",
      "CREATED": "Izveidots",
      "DURATION": "Ilgums",
      "INITIATED_BY": "Started by",
      "PROGRESS": "Import progress",
      "PROGRESS_WITH_TOTAL": "{imported} of {total} imported",
      "PROGRESS_WITHOUT_TOTAL": "{imported} imported",
      "PROGRESS_OF_TOTAL": "of {total} imported",
      "PROGRESS_IMPORTED": "imported",
      "LAST_UPDATED_TOOLTIP": "Last updated {time}",
      "NO_SKIP_LOGS": "No skipped or failed records recorded.",
      "DOWNLOAD_SKIP_LOGS": "Download CSV",
      "DOWNLOAD_ERROR_LOGS": "Download CSV",
      "ALL_SKIP_LOGS": "Visi",
      "KIND": "Kind",
      "NO_ERRORS": "No errors recorded.",
      "ERROR_CODE": "Code",
      "SOURCE_OBJECT": "Source object",
      "MESSAGE": "Ziņojums"
    },
    "MONITOR": {
      "LIVE": "Live updates every {seconds}s",
      "LAST_UPDATED": "Last updated {time}",
      "REFRESH": "Atjaunot",
      "REFRESHING": "Refreshing",
      "STAGES": {
        "unknown": "Waiting for update",
        "queued": "Queued",
        "contacts": "Importing contacts",
        "conversations": "Importing conversations",
        "finalizing": "Finalizing import",
        "completed": "Pabeigts",
        "completed_with_errors": "Completed with errors",
        "failed": "Failed",
        "abandoned": "Abandoned"
      }
    },
    "ALERTS": {
      "IMPORT_STARTED": "Intercom import has started.",
      "IMPORT_ABANDONED": "Intercom import has been abandoned.",
      "IMPORT_FAILED": "Could not start the Intercom import."
    }
  },
  "CAPTAIN_SETTINGS": {
    "TITLE": "Captain Settings",
    "DESCRIPTION": "Configure your AI models and features for Captain. Captain follows a credit based billing, you will be charged credits for every action Captain takes based on the model selected.",
    "LOADING": "Loading Captain configuration...",
    "LINK_TEXT": "Learn more about Captain Credits",
    "NOT_ENABLED": "Captain is not enabled for your account. Please upgrade your plan to access Captain features.",
    "MODEL_CONFIG": {
      "TITLE": "Model Configuration",
      "DESCRIPTION": "Select AI models for different features.",
      "SELECT_MODEL": "Select model",
      "CREDITS_PER_MESSAGE": "{credits} credit/message",
      "COMING_SOON": "Coming soon",
      "EDITOR": {
        "TITLE": "Editor Features",
        "DESCRIPTION": "Powers smart compose, grammar corrections, tone adjustments, and content enhancement in your message editor."
      },
      "ASSISTANT": {
        "TITLE": "Asistents",
        "DESCRIPTION": "Handles automated responses, conversation summaries, and intelligent reply suggestions for customer interactions."
      },
      "COPILOT": {
        "TITLE": "Co-pilot",
        "DESCRIPTION": "Provides real-time contextual suggestions, knowledge base recommendations, and proactive insights during conversations."
      }
    },
    "FEATURES": {
      "TITLE": "Īpašības",
      "DESCRIPTION": "Enable or disable AI-powered features.",
      "AUDIO_TRANSCRIPTION": {
        "TITLE": "Audio Transcription",
        "DESCRIPTION": "Automatically convert voice messages and call recordings into searchable text transcripts.",
        "MODEL_TITLE": "Audio Transcription Model",
        "MODEL_DESCRIPTION": "Select the AI model to use for converting audio messages into text transcripts"
      },
      "HELP_CENTER_SEARCH": {
        "TITLE": "Help Center Search Indexing",
        "DESCRIPTION": "Use AI for context aware search inside your help center articles."
      },
      "LABEL_SUGGESTION": {
        "TITLE": "Label Suggestion",
        "DESCRIPTION": "Automatically suggest relevant labels and tags for conversations based on content analysis and context.",
        "MODEL_TITLE": "Label Suggestion Model",
        "MODEL_DESCRIPTION": "Select the AI model to use for analyzing conversations and suggesting appropriate labels"
      }
    },
    "API": {
      "SUCCESS": "Captain settings updated successfully.",
      "ERROR": "Failed to update Captain settings. Please try again."
    }
  },
  "BILLING_SETTINGS": {
    "TITLE": "Norēķini",
    "DESCRIPTION": "Pārvaldiet savu abonementu šeit. Modernizējiet abonementu un iegūstiet papildu funkcijas savai komandai.",
    "CURRENT_PLAN": {
      "TITLE": "Pašreizējais Norēķinu Plāns",
      "PLAN_NOTE": "Šobrīd Jūs abonējat **{plan}** plānu ar **{quantity}** licencēm",
      "SEAT_COUNT": "Lietotāju skaits",
      "RENEWS_ON": "Atjaunojas",
      "CURRENCY": "Currency"
    },
    "CURRENCY": {
      "SELECT": {
        "TITLE": "Choose your billing currency",
        "DESCRIPTION": "Select the currency you'd like to be billed in. This can't be changed once your subscription is created."
      },
      "OPTIONS": {
        "USD": "US Dollar (USD)",
        "BRL": "Brazilian Real (BRL)"
      }
    },
    "VIEW_PRICING": "Skatīt Izcenojumu",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "Pārvaldīt savu abonementu",
      "DESCRIPTION": "Apskatīt iepriekšējos rēķinus, rediģēt norēķinu informāciju vai atcelt abonementu.",
      "BUTTON_TXT": "Doties uz norēķinu portālu"
    },
    "CAPTAIN": {
      "TITLE": "Captain",
      "DESCRIPTION": "Pārvaldīt Captain AI lietošanu un kredītus.",
      "BUTTON_TXT": "Iegādāties vairāk kredītu",
      "DOCUMENTS": "Dokumenti",
      "RESPONSES": "Atbildes",
      "UPGRADE": "Captain nav pieejams bezmaksas abonementā. Modernizējiet abonementu tūlīt, lai piekļūtu asistentiem un copilot.",
      "REFRESH_CREDITS": "Atjaunot"
    },
    "CHAT_WITH_US": {
      "TITLE": "Nepieciešama palīdzība?",
      "DESCRIPTION": "Vai Jūs saskārāties ar kādām problēmām norēķinu laikā? Mēs esam šeit, lai palīdzētu.",
      "BUTTON_TXT": "Tērzēt ar mums"
    },
    "NO_BILLING_USER": "Jūsu norēķinu konts tiek konfigurēts. Lūdzu, atsvaidziniet lapu un mēģiniet vēlreiz.",
    "TOPUP": {
      "BUY_CREDITS": "Iegādāties vairāk kredītu",
      "MODAL_TITLE": "Buy AI Credits",
      "MODAL_DESCRIPTION": "Purchase additional credits for Captain AI.",
      "CREDITS": "CREDITS",
      "ONE_TIME": "one-time",
      "POPULAR": "Most Popular",
      "NOTE_TITLE": "Piezīme:",
      "NOTE_DESCRIPTION": "Credits are added immediately and expire in 6 months. An active subscription is required to use credits. Purchased credits are consumed after your monthly plan credits.",
      "CANCEL": "Atcelt",
      "PURCHASE": "Purchase Credits",
      "LOADING": "Loading options...",
      "FETCH_ERROR": "Failed to load credit options. Please try again.",
      "RETRY": "Retry",
      "PURCHASE_ERROR": "Failed to process purchase. Please try again.",
      "PURCHASE_SUCCESS": "Successfully added {credits} credits to your account",
      "CONFIRM": {
        "TITLE": "Confirm Purchase",
        "DESCRIPTION": "You are about to purchase {credits} credits for {amount}.",
        "INSTANT_DEDUCTION_NOTE": "Your saved card will be charged immediately upon confirmation.",
        "GO_BACK": "Atgriezties",
        "CONFIRM_PURCHASE": "Confirm Purchase"
      }
    }
  },
  "SECURITY_SETTINGS": {
    "TITLE": "Security",
    "DESCRIPTION": "Manage your account security settings.",
    "LINK_TEXT": "Learn more about SAML SSO",
    "SAML_DISABLED_MESSAGE": "SAML SSO is currently disabled. Please contact your administrator to enable this feature.",
    "SAML": {
      "TITLE": "SAML SSO",
      "NOTE": "Configure SAML single sign-on for your account. Users will authenticate through your identity provider instead of using email/password.",
      "ACS_URL": {
        "LABEL": "ACS URL",
        "TOOLTIP": "Assertion Consumer Service URL - Configure this URL in your IdP as the destination for SAML responses"
      },
      "SSO_URL": {
        "LABEL": "SSO URL",
        "HELP": "The URL where SAML authentication requests will be sent",
        "PLACEHOLDER": "https://your-idp.com/saml/sso"
      },
      "CERTIFICATE": {
        "LABEL": "Signing certificate in PEM format",
        "HELP": "The public certificate from your identity provider used to verify SAML responses",
        "PLACEHOLDER": "-----BEGIN CERTIFICATE-----\nMIIC..."
      },
      "FINGERPRINT": {
        "LABEL": "Fingerprint",
        "TOOLTIP": "SHA-1 fingerprint of the certificate - Use this to verify the certificate in your IdP configuration"
      },
      "COPY_SUCCESS": "Kopēts starpliktuvē",
      "SP_ENTITY_ID": {
        "LABEL": "SP Entity ID",
        "HELP": "Unique identifier for this application as a service provider (auto-generated).",
        "TOOLTIP": "Unique identifier for Chatwoot as the Service Provider - Configure this in your IdP settings"
      },
      "IDP_ENTITY_ID": {
        "LABEL": "Identity Provider Entity ID",
        "HELP": "Unique identifier for your identity provider (usually found in IdP configuration)",
        "PLACEHOLDER": "https://your-idp.com/saml"
      },
      "UPDATE_BUTTON": "Update SAML Settings",
      "API": {
        "SUCCESS": "SAML settings updated successfully",
        "ERROR": "Failed to update SAML settings",
        "ERROR_LOADING": "Failed to load SAML settings",
        "DISABLED": "SAML settings disabled successfully"
      },
      "VALIDATION": {
        "REQUIRED_FIELDS": "SSO URL, Identity Provider Entity ID, and Certificate are required fields",
        "SSO_URL_ERROR": "Please enter a valid SSO URL",
        "CERTIFICATE_ERROR": "Certificate is required",
        "IDP_ENTITY_ID_ERROR": "Identity Provider Entity ID is required"
      },
      "ENTERPRISE_PAYWALL": {
        "AVAILABLE_ON": "The SAML SSO feature is only available in the Enterprise plans.",
        "UPGRADE_PROMPT": "Upgrade to an Enterprise plan to access SAML single sign-on and other advanced security features.",
        "ASK_ADMIN": "Lai pārietu uz maksas versiju, lūdzu sazinieties ar savu administratoru."
      },
      "PAYWALL": {
        "TITLE": "Upgrade to enable SAML SSO",
        "AVAILABLE_ON": "The SAML SSO feature is only available in the Enterprise plans.",
        "UPGRADE_PROMPT": "Upgrade your plan to get access to SAML single sign-on and other advanced features.",
        "UPGRADE_NOW": "Pāriet uz maksas versiju tagad",
        "CANCEL_ANYTIME": "Jūs varat jebkurā laikā mainīt vai atcelt savu versiju"
      },
      "ATTRIBUTE_MAPPING": {
        "TITLE": "SAML Attribute Setup",
        "DESCRIPTION": "The following attribute mappings must be configured in your identity provider"
      },
      "INFO_SECTION": {
        "TITLE": "Service Provider Information",
        "TOOLTIP": "Copy these values and configure them in your Identity Provider to establish the SAML connection"
      }
    }
  },
  "CONVERSATION_WORKFLOW": {
    "INDEX": {
      "HEADER": {
        "TITLE": "Conversation Workflows",
        "DESCRIPTION": "Configure rules and required fields for conversation resolution."
      }
    },
    "REQUIRED_ATTRIBUTES": {
      "TITLE": "Attributes required on resolution",
      "DESCRIPTION": "When resolving a conversation, agents will be prompted to fill these attributes if they haven't yet.",
      "NO_ATTRIBUTES": "No attributes added yet",
      "ADD": {
        "TITLE": "Add Attributes",
        "SEARCH_PLACEHOLDER": "Meklēt īpašības"
      },
      "SAVE": {
        "SUCCESS": "Required attributes updated",
        "ERROR": "Could not update required attributes, please try again"
      },
      "MODAL": {
        "TITLE": "Atrisināt sarunu",
        "DESCRIPTION": "Please fill in the following custom attributes before resolving this conversation",
        "ACTIONS": {
          "RESOLVE": "Atrisināt sarunu",
          "CANCEL": "Atcelt"
        },
        "PLACEHOLDERS": {
          "TEXT": "Write a note...",
          "NUMBER": "Enter a number",
          "LINK": "Add a link",
          "DATE": "Pick a date",
          "LIST": "Izvēlieties opciju"
        },
        "CHECKBOX": {
          "YES": "Jā",
          "NO": "Nē"
        }
      },
      "PAYWALL": {
        "TITLE": "Upgrade to use required attributes",
        "AVAILABLE_ON": "The required conversation attributes feature is available on the Business and Enterprise plans.",
        "UPGRADE_PROMPT": "Upgrade your plan to prompt agents to fill required attributes before conversation resolution.",
        "UPGRADE_NOW": "Pāriet uz maksas versiju tagad",
        "CANCEL_ANYTIME": "Jūs varat jebkurā laikā mainīt vai atcelt savu versiju"
      },
      "ENTERPRISE_PAYWALL": {
        "AVAILABLE_ON": "The required conversation attributes feature is available on the paid plans.",
        "UPGRADE_PROMPT": "Upgrade to a paid plan to enforce required attributes before conversation resolution.",
        "ASK_ADMIN": "Lai pārietu uz maksas versiju, lūdzu sazinieties ar savu administratoru."
      }
    }
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "Ak, vai! Mēs nevarējām atrast nevienu chatwoot kontu. Lūdzu, izveidojiet jaunu kontu, lai turpinātu.",
    "NEW_ACCOUNT": "Jauns Konts",
    "SELECTOR_SUBTITLE": "Izveidot jaunu kontu",
    "API": {
      "SUCCESS_MESSAGE": "Konts ir veiksmīgi izveidots",
      "EXIST_MESSAGE": "Konts jau pastāv",
      "ERROR_MESSAGE": "Nevar izveidot savienojumu ar Woot serveri. Lūdzu, vēlāk pamēģiniet vēlreiz"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Uzņēmuma Nosaukums",
        "PLACEHOLDER": "Wayne Enterprises"
      },
      "SUBMIT": "Iesniegt",
      "CANCEL": "Atcelt"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "Skatīt visus īsinājumtaustiņus",
    "TITLE": {
      "OPEN_CONVERSATION": "Atvērt sarunu",
      "RESOLVE_AND_NEXT": "Atrisināt un pāriet uz nākamo",
      "NAVIGATE_DROPDOWN": "Pārvietoties starp nolaižamā saraksta vienumiem",
      "RESOLVE_CONVERSATION": "Atrisināt Sarunu",
      "GO_TO_CONVERSATION_DASHBOARD": "Doties uz Sarunu Informācijas Paneli",
      "ADD_ATTACHMENT": "Pievienot Pielikumu",
      "GO_TO_CONTACTS_DASHBOARD": "Doties uz Kontaktu Informācijas Paneli",
      "TOGGLE_SIDEBAR": "Pārslēgt Sānjoslu",
      "GO_TO_REPORTS_SIDEBAR": "Doties uz Pārskatu sānjoslu",
      "MOVE_TO_NEXT_TAB": "Pāriet uz sarunu saraksta nākamo cilni",
      "GO_TO_SETTINGS": "Doties uz Iestatījumiem",
      "SWITCH_TO_PRIVATE_NOTE": "Pārslēgties uz Privāto Piezīmi",
      "SWITCH_TO_REPLY": "Pārslēgties uz Atbildi",
      "TOGGLE_SNOOZE_DROPDOWN": "Pārslēgt atlikšanas nolaižamo izvēlni"
    }
  },
  "ASSIGNMENT_POLICY": {
    "INDEX": {
      "HEADER": {
        "TITLE": "Agent assignment",
        "DESCRIPTION": "Define policies to effectively manage workload and route conversations based on the needs of inboxes and agents. Learn more here"
      },
      "ASSIGNMENT_POLICY": {
        "TITLE": "Assignment policy",
        "DESCRIPTION": "Manage how conversations get assigned in inboxes.",
        "FEATURES": [
          "Assign by conversations evenly or by available capacity",
          "Add fair distribution rules to avoid overloading any agent",
          "Add inboxes to a policy - one policy per inbox"
        ]
      },
      "AGENT_CAPACITY_POLICY": {
        "TITLE": "Agent capacity policy",
        "DESCRIPTION": "Manage workload for agents.",
        "FEATURES": [
          "Define maximum conversations per inbox",
          "Create exceptions based on labels and time",
          "Add agents to a policy - one policy per agent"
        ]
      }
    },
    "AGENT_ASSIGNMENT_POLICY": {
      "INDEX": {
        "HEADER": {
          "TITLE": "Assignment policy",
          "CREATE_POLICY": "New policy"
        },
        "CARD": {
          "ORDER": "Order",
          "PRIORITY": "Prioritāte",
          "ACTIVE": "Aktīvs",
          "INACTIVE": "Inactive",
          "POPOVER": "Added inboxes",
          "EDIT": "Rediģēt"
        },
        "NO_RECORDS_FOUND": "No assignment policies found"
      },
      "CREATE": {
        "HEADER": {
          "TITLE": "Create assignment policy"
        },
        "CREATE_BUTTON": "Create policy",
        "API": {
          "SUCCESS_MESSAGE": "Assignment policy created successfully",
          "ERROR_MESSAGE": "Failed to create assignment policy",
          "INBOX_LINKED": "Inbox has been linked to the policy"
        }
      },
      "EDIT": {
        "HEADER": {
          "TITLE": "Edit assignment policy"
        },
        "EDIT_BUTTON": "Update policy",
        "CONFIRM_ADD_INBOX_DIALOG": {
          "TITLE": "Add inbox",
          "DESCRIPTION": "{inboxName} inbox is already linked to another policy. Are you sure you want to link it to this policy? It will be unlinked from the other policy.",
          "CONFIRM_BUTTON_LABEL": "Continue",
          "CANCEL_BUTTON_LABEL": "Atcelt"
        },
        "INBOX_LINK_PROMPT": {
          "TITLE": "Link inbox to policy",
          "DESCRIPTION": "Would you like to link this inbox to the assignment policy?",
          "LINK_BUTTON": "Link inbox",
          "CANCEL_BUTTON": "Skip"
        },
        "API": {
          "SUCCESS_MESSAGE": "Assignment policy updated successfully",
          "ERROR_MESSAGE": "Failed to update assignment policy"
        },
        "INBOX_API": {
          "ADD": {
            "SUCCESS_MESSAGE": "Inbox added to policy successfully",
            "ERROR_MESSAGE": "Failed to add inbox to policy"
          },
          "REMOVE": {
            "SUCCESS_MESSAGE": "Inbox removed from policy successfully",
            "ERROR_MESSAGE": "Failed to remove inbox from policy"
          }
        }
      },
      "FORM": {
        "NAME": {
          "LABEL": "Policy name:",
          "PLACEHOLDER": "Enter policy name"
        },
        "DESCRIPTION": {
          "LABEL": "Apraksts:",
          "PLACEHOLDER": "Ievadiet aprakstu"
        },
        "STATUS": {
          "LABEL": "Statuss:",
          "PLACEHOLDER": "Izvēlēties statusu",
          "ACTIVE": "Policy is active",
          "INACTIVE": "Policy is inactive"
        },
        "ASSIGNMENT_ORDER": {
          "LABEL": "Assignment order",
          "ROUND_ROBIN": {
            "LABEL": "Round robin",
            "DESCRIPTION": "Assign conversations evenly among agents."
          },
          "BALANCED": {
            "LABEL": "Balanced",
            "DESCRIPTION": "Assign conversations based on available capacity.",
            "PREMIUM_MESSAGE": "Upgrade to access balanced assignment and agent capacity management.",
            "PREMIUM_BADGE": "Premium"
          }
        },
        "ASSIGNMENT_PRIORITY": {
          "LABEL": "Assignment priority",
          "EARLIEST_CREATED": {
            "LABEL": "Earliest created",
            "DESCRIPTION": "The conversation that was created first gets assigned first."
          },
          "LONGEST_WAITING": {
            "LABEL": "Longest waiting",
            "DESCRIPTION": "The conversation waiting the longest gets assigned first."
          }
        },
        "FAIR_DISTRIBUTION": {
          "LABEL": "Fair distribution policy",
          "DESCRIPTION": "Set the maximum number of conversations that can be assigned per agent within a time window to avoid overloading any one agent. This required field defaults to 100 conversations per hour.",
          "INPUT_MAX": "Assign max",
          "DURATION": "Conversations per agent in every"
        },
        "EXCLUDE_OLDER_THAN": {
          "LABEL": "Skip stale conversations",
          "DESCRIPTION": "Skip unassigned conversations older than this. Defaults to 7 days; clear to disable."
        },
        "INBOXES": {
          "LABEL": "Added inboxes",
          "DESCRIPTION": "Add inboxes for which this policy will be applicable.",
          "ADD_BUTTON": "Add inbox",
          "DROPDOWN": {
            "SEARCH_PLACEHOLDER": "Search and select inboxes to add",
            "ADD_BUTTON": "Pievienot"
          },
          "EMPTY_STATE": "No inboxes added to this policy, add an inbox to get started",
          "API": {
            "SUCCESS_MESSAGE": "Inbox successfully added to policy",
            "ERROR_MESSAGE": "Failed to add inbox to policy"
          }
        }
      },
      "DELETE_POLICY": {
        "SUCCESS_MESSAGE": "Assignment policy deleted successfully",
        "ERROR_MESSAGE": "Failed to delete assignment policy"
      }
    },
    "AGENT_CAPACITY_POLICY": {
      "INDEX": {
        "HEADER": {
          "TITLE": "Agent capacity",
          "CREATE_POLICY": "New policy"
        },
        "CARD": {
          "POPOVER": "Added agents",
          "EDIT": "Rediģēt"
        },
        "NO_RECORDS_FOUND": "No agent capacity policies found"
      },
      "CREATE": {
        "HEADER": {
          "TITLE": "Create agent capacity policy"
        },
        "CREATE_BUTTON": "Create policy",
        "API": {
          "SUCCESS_MESSAGE": "Agent capacity policy created successfully",
          "ERROR_MESSAGE": "Failed to create agent capacity policy"
        }
      },
      "EDIT": {
        "HEADER": {
          "TITLE": "Edit agent capacity policy"
        },
        "EDIT_BUTTON": "Update policy",
        "CONFIRM_ADD_AGENT_DIALOG": {
          "TITLE": "Add agent",
          "DESCRIPTION": "{agentName} is already linked to another policy. Are you sure you want to link it to this policy? It will be unlinked from the other policy.",
          "CONFIRM_BUTTON_LABEL": "Continue",
          "CANCEL_BUTTON_LABEL": "Atcelt"
        },
        "API": {
          "SUCCESS_MESSAGE": "Agent capacity policy updated successfully",
          "ERROR_MESSAGE": "Failed to update agent capacity policy"
        },
        "AGENT_API": {
          "ADD": {
            "SUCCESS_MESSAGE": "Agent added to policy successfully",
            "ERROR_MESSAGE": "Failed to add agent to policy"
          },
          "REMOVE": {
            "SUCCESS_MESSAGE": "Agent removed from policy successfully",
            "ERROR_MESSAGE": "Failed to remove agent from policy"
          }
        },
        "INBOX_LIMIT_API": {
          "ADD": {
            "SUCCESS_MESSAGE": "Inbox limit added successfully",
            "ERROR_MESSAGE": "Failed to add inbox limit"
          },
          "UPDATE": {
            "SUCCESS_MESSAGE": "Inbox limit updated successfully",
            "ERROR_MESSAGE": "Failed to update inbox limit"
          },
          "DELETE": {
            "SUCCESS_MESSAGE": "Inbox limit deleted successfully",
            "ERROR_MESSAGE": "Failed to delete inbox limit"
          }
        }
      },
      "FORM": {
        "NAME": {
          "LABEL": "Policy name:",
          "PLACEHOLDER": "Enter policy name"
        },
        "DESCRIPTION": {
          "LABEL": "Apraksts:",
          "PLACEHOLDER": "Ievadiet aprakstu"
        },
        "INBOX_CAPACITY_LIMIT": {
          "LABEL": "Inbox capacity limits",
          "ADD_BUTTON": "Add inbox",
          "FIELD": {
            "SELECT_INBOX": "Select inbox",
            "MAX_CONVERSATIONS": "Max conversations",
            "SET_LIMIT": "Set limit"
          },
          "EMPTY_STATE": "No inbox limit set"
        },
        "EXCLUSION_RULES": {
          "LABEL": "Exclusion rules",
          "DESCRIPTION": "Conversations that satisfy the following conditions would not count towards agent capacity",
          "TAGS": {
            "LABEL": "Exclude conversations tagged with specific labels",
            "ADD_TAG": "add tag",
            "DROPDOWN": {
              "SEARCH_PLACEHOLDER": "Search and select tags to add"
            },
            "EMPTY_STATE": "No tags added to this policy."
          },
          "DURATION": {
            "LABEL": "Exclude conversations older than a specified duration",
            "PLACEHOLDER": "Set time"
          }
        },
        "USERS": {
          "LABEL": "Assigned agents",
          "DESCRIPTION": "Add agents for which this policy will be applicable.",
          "ADD_BUTTON": "Add agent",
          "DROPDOWN": {
            "SEARCH_PLACEHOLDER": "Search and select agents to add",
            "ADD_BUTTON": "Pievienot"
          },
          "EMPTY_STATE": "No agents added",
          "API": {
            "SUCCESS_MESSAGE": "Agent successfully added to policy",
            "ERROR_MESSAGE": "Failed to add agent to policy"
          }
        }
      },
      "DELETE_POLICY": {
        "SUCCESS_MESSAGE": "Agent capacity policy deleted successfully",
        "ERROR_MESSAGE": "Failed to delete agent capacity policy"
      }
    },
    "DELETE_POLICY": {
      "TITLE": "Delete policy",
      "DESCRIPTION": "Are you sure you want to delete this policy? This action cannot be undone.",
      "CONFIRM_BUTTON_LABEL": "Dzēst",
      "CANCEL_BUTTON_LABEL": "Atcelt"
    }
  }
}
